import React from 'react'
import { store } from '../store'
import { AppointmentQueryParams } from './useAppointmentQueryParams'

type ContextRefs = {
  businessId?: string
  resourceId?: string
}

export const useResolvedAppointmentContext = (params: AppointmentQueryParams) => {
  const { id, queryBusinessId, queryResourceId } = params
  const defaultBusinessId = store.profile.businessId || undefined
  const defaultResourceId = store.profile.resource?.id || undefined

  const keyRef = React.useRef('')
  const contextRef = React.useRef<ContextRefs>({
    businessId: queryBusinessId || defaultBusinessId,
    resourceId: queryResourceId || defaultResourceId,
  })

  React.useEffect(() => {
    const key = [id, queryBusinessId || '', queryResourceId || ''].join('|')
    if (keyRef.current !== key) {
      keyRef.current = key
      contextRef.current = {
        businessId: queryBusinessId || defaultBusinessId,
        resourceId: queryResourceId || defaultResourceId,
      }
    }
  }, [id, queryBusinessId, queryResourceId, defaultBusinessId, defaultResourceId])

  React.useEffect(() => {
    if (!queryResourceId && defaultResourceId) {
      contextRef.current = {
        ...contextRef.current,
        resourceId: contextRef.current.resourceId || defaultResourceId
      }
    }
  }, [defaultResourceId, queryResourceId])

  const appointmentContext = store.appointments.appointment?.appointment.context
  React.useEffect(() => {
    if (!appointmentContext) return
    if (!contextRef.current.businessId && appointmentContext.businessId) {
      contextRef.current = { ...contextRef.current, businessId: appointmentContext.businessId }
    }
    if (!contextRef.current.resourceId && appointmentContext.resourceId) {
      contextRef.current = { ...contextRef.current, resourceId: appointmentContext.resourceId }
    }
  }, [appointmentContext?.businessId, appointmentContext?.resourceId])

  return contextRef.current
}
